import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { EASE, fadeUp } from "../../lib/motion";
import { useModal } from "../../lib/ModalContext";

export const CTA = ({ content }) => {
    const c = content?.cta || {};
    const { open } = useModal();
    return (
        <section className="relative py-10 md:py-24" data-testid="cta-section">
            <div className="mx-auto max-w-[1240px] px-6 md:px-10 text-center">
                <motion.h2
                    initial={{ opacity: 0, y: 30, filter: "blur(10px)" }}
                    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 1.15, ease: EASE }}
                    className="font-display font-semibold text-[44px] sm:text-[60px] md:text-[80px] lg:text-[96px] leading-[1.0] tracking-[-0.04em] max-w-[1020px] mx-auto"
                    data-testid="cta-headline"
                >
                    {c.headline}
                </motion.h2>
                <motion.p {...fadeUp(0.25)} className="mt-8 font-body text-base md:text-lg text-oth-ink3 max-w-[520px] mx-auto" data-testid="cta-subtext">
                    {c.subtext}
                </motion.p>
                <motion.button
                    {...fadeUp(0.4)}
                    type="button"
                    onClick={() => open("book")}
                    className="btn-pill btn-pill-dark mt-12 text-base"
                    data-testid="cta-button"
                >
                    {c.cta_label || "Book a private demo"} <ArrowUpRight size={16} />
                </motion.button>
            </div>
        </section>
    );
};
